<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 65px;">
                    <div class="header-logo">
                        <img id="header-img" src="./assets/logo.png">
                    </div>
                </div>
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <div class="company_name">上海梦匠桓屿信息科技</div>
                        <div class="header-title company_name">www.mengjianghuanyu.com</div>
                    </div>
                </div>
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" 
                         text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                    <!-- <el-menu-item index="1" class="header-title">首页</el-menu-item> -->
                    <el-menu-item index="2" class="header-title">公司概况</el-menu-item>
                    <el-menu-item index="3" class="header-title">服务能力</el-menu-item>
                    <el-menu-item index="4" class="header-title">合作流程</el-menu-item>
                    <el-menu-item index="5" class="header-title">售后保障</el-menu-item>
                    <el-menu-item index="6" class="header-title">合作伙伴</el-menu-item>
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
                         text-color="#333" style="height: 65px; border:0;" mode="horizontal"
                         @select="handleSelectMobile">
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                         <el-menu-item index="2" class="header-title">公司概况</el-menu-item>
                        <el-menu-item index="3" class="header-title">服务能力</el-menu-item>
                        <el-menu-item index="4" class="header-title">合作流程</el-menu-item>
                        <el-menu-item index="5" class="header-title">售后保障</el-menu-item>
                        <el-menu-item index="6" class="header-title">合作伙伴</el-menu-item>
                    <!-- <el-sub-menu index="2" class="header-title mobile_menu">
                        <template #title>{{currentMenu}}</template>
                        
                    </el-sub-menu> -->
                </el-menu>
            </div>
        </div>
        <div class="container" >
            <router-view></router-view>
        </div>

        <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div>
        <div style="width: 90%;margin: 20px auto;">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12">
                    <p class="footer_font hand">地址：上海青浦区诸光路1588弄1号绿地全球商品贸易港7楼706</p>
                    <p class="footer_font hand">联系电话：17321119425</p>
                    <p class="footer_font hand">邮箱：476049168@qq.com</p>
                    <div style="margin: auto;" class="footer_font hand">
                        互联网ICP备案：
                        <a href="http://beian.miit.gov.cn/" target="_blank" >沪ICP备2024084416号-1</a>
                    </div>
                    <div style="margin: auto;" class="footer_font hand">
                        www.mengjianghuanyu.com 上海梦匠桓屿信息科技有限公司版权所有
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div><img src="./assets/logo.png" style="width: 100px;height: 100px;border: 0"/></div>
                    <div class="footer_font hand">上海梦匠桓屿信息科技有限公司</div>
                </el-col>
            </el-row>
        </div>
        <div id="back_to_top" :class="isShowBtn?'showBtn':'noShowBtn'" @click="backTop">
            <img src="./assets/icon/toTop.png" style="height: 30px;width: 30px"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {
                activeIndex: '2',
                scroll: '',
                timer: '',
                seen: true,
                currentMenu: '公司概况',
                isShowBtn:false,
            };
        },
        methods: {
            handleSelect(key) {
                switch (key) {
                    // case '1':
                    //     this.$router.push({name: "Index"});
                    //     break;
                    case '2':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#公司概况";
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#服务能力";
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作流程";
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#售后保障";
                        break;
                    case '6':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        break;
                }
            },
            handleSelectMobile(key) {
                switch (key) {
                    // case '1':
                    //     this.$router.push({name: "Index"});
                    //     this.currentMenu = '首页';
                    //     break;
                    case '2':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#公司概况";
                        this.currentMenu = '首页';
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#服务能力";
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作流程";
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#售后保障";
                        break;
                    case '6':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        break;
                }
            },
            handleScroll() {
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                // 1180 2520 3080 3650
                if (this.scroll > 600) {
                    //判断滚动后高度超过400px,就显示
                    this.isShowBtn=true;
                } else {
                    this.isShowBtn=false
                }
            },
            backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            menuSeen() {
                // 屏幕尺寸
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    this.seen = true;
                } else {
                    this.seen = false;
                }
            },
            logoClick() {
                this.$router.push({name: "Index"});
                this.currentMenu = '首页';
            }
        },
        mounted() {
            this.menuSeen()
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped>
    .logo_img {
        float: left;
        width: 30%;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }

    .header-title {
        font-size: 1em;
    }

    .company_name {
        font-weight: normal;
        font-size: 1em;
    }

    .footer_font {
        font-size: 1em;
    }

    #menu_index {
        float: left;
        width: 70%;
        height: 100%
    }

    .header {
        margin: auto;
        width: 90%;
        height: 65px;
        position: sticky;
        top: 0;
        left: 0;
        background: #fff;
        opacity: 1;
        padding: 0 5% 15px;
        /*background: #F56C6C;*/
    }

    @media screen and (max-device-width: 415px) {
        .logo_img {
            float: left;
            width: auto;
            cursor: pointer;
        }

        #back_to_top {
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }

        .footer_font {
            font-size: 0.875em;
        }

        #menu_index {
            float: right;
            width: auto;
            height: 100%
        }

    }

    #header-img {
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }

    .header-logo {
        height: 50px;
        width: 50px;
        align-self: center;
    }

    .header-important {
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer {
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }

    a {
        text-decoration: none;
    }

    a:visited {
        text-decoration: none;
    }

    a:hover {
        text-decoration: none;
    }

    a:active {
        text-decoration: none;
    }
    .showBtn{ 
        display: block;
    }
    .noShowBtn{
        display: none;
    }

    .hand{ 
        cursor: pointer;
    }
</style>